import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { IPagedResults } from '../../core/interfaces';
import { SettingsService } from '../../services/settings.service';
import { modalLarge } from '../../shared/modules/dialogOptions';
import { SettingEditComponent } from './setting-edit.component';

@Component({
    selector: 'app-setting-list',
    templateUrl: './setting-list.component.html',
    styleUrls: ['./setting-list.component.scss']
})
export class SettingListComponent implements OnInit {
    public siteId: number;
    public showSpinner: boolean = false;
    public itemPerPage: number = 10;
    public currentPage: number = 1;
    public totalItems: number = 10;
    public isAdminOrUserEditor = false;
    public isSuperAdmin = false; 5
    public isPreviewOn: boolean = false;
    constructor(private router: Router,
        private route: ActivatedRoute,
        private toastr: ToastsManager,
        private modalService: NgbModal,
        private settingService: SettingsService) { }
    packageData: Subject<any> = new Subject<any[]>();

    ngOnInit() {

    }


    public loadData(page?: number, id?: number) {
        //    
        this.showSpinner = true;
        let filter = '';
        if (page != null) {
            this.currentPage = page;
        }
        var moduleId = +localStorage.getItem('currentModuleId');

        var siteId = +localStorage.getItem('currentSiteId');
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.settingService.getSettings(currentUser.accountId, moduleId, siteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: IPagedResults<any>) => {
                this.packageData.next(response.Data);
                this.totalItems = response.Data.length;
                // this.toastr.success(response.Message, "Success"); 
            });
    }

    public loadDataById(accountId: number, siteId: number) {
        this.showSpinner = true;
        let filter = '';
        var moduleId = +localStorage.getItem('currentModuleId');
        // var siteId = +localStorage.getItem('currentSiteId');

        this.settingService.getSettings(accountId, moduleId, siteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: IPagedResults<any>) => {
                this.packageData.next(response.Data);

                this.totalItems = response.Data.length;
            });
    }

    public editSetting(id: number) {

        //this.router.navigate([`${id}/edit`], { relativeTo: this.route });  
        const modalRef = this.modalService.open(SettingEditComponent, modalLarge);
        modalRef.componentInstance.modalIdData = id;
        modalRef.result.then((result) => {
            this.ngOnInit();
            //alert(result);
            var currentUser = JSON.parse(localStorage.getItem('currentUser'));
            var siteId = +localStorage.getItem('currentSiteId');
            this.loadDataById(currentUser.accountId, siteId);
        }, (reason) => {
            this.ngOnInit();
            // alert(reason +"aaa");
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/setting/setting-list.component.ts